import { Link } from "react-router-dom";

export default function IntroSection() {
  return (
    <section className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
      <div className="lg:col-span-2 bg-background-100 border border-background-200 rounded-lg p-6 md:p-8">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
          <i className="ri-home-smile-line"></i> 关于邻居
        </span>
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 leading-snug">
          邻居，让社区里的每一次相遇都更温暖
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
          邻居是一个本地社区交流平台，我们相信，好的邻里关系从一次打招呼开始。在这里，你可以了解社区新闻与活动，参与邻里论坛的讨论，发布求助与帮忙，也能查找和分享身边的生活服务信息。
        </p>
        <p className="text-sm md:text-base text-foreground-600 mt-3 leading-relaxed">
          平台定位服务本地居民与社区成员，旨在促进信息分享与互动，增进邻里友谊，共同营造互助、信任、和谐的社区氛围。
        </p>
        <div className="flex flex-wrap gap-3 mt-6">
          <Link to="/about" className="inline-flex items-center gap-1 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap">
            了解更多 <i className="ri-arrow-right-line"></i>
          </Link>
          <Link to="/post" className="inline-flex items-center gap-1 h-10 px-5 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-50 transition-colors whitespace-nowrap">
            <i className="ri-edit-2-line"></i> 发布一条信息
          </Link>
        </div>
      </div>

      <div className="bg-secondary-50 border border-secondary-200 rounded-lg p-6 md:p-8">
        <span className="w-10 h-10 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center mb-4">
          <i className="ri-heart-2-line text-xl"></i>
        </span>
        <h3 className="text-base font-bold text-foreground-950 mb-3">温馨提示</h3>
        <ul className="space-y-3 text-sm text-foreground-600 leading-relaxed">
          <li className="flex gap-2"><i className="ri-checkbox-circle-line text-secondary-500 mt-0.5"></i> 发布信息请确保内容真实、友善，共建和谐社区。</li>
          <li className="flex gap-2"><i className="ri-checkbox-circle-line text-secondary-500 mt-0.5"></i> 涉及上门服务请当面核实身份，注意人身与财产安全。</li>
          <li className="flex gap-2"><i className="ri-checkbox-circle-line text-secondary-500 mt-0.5"></i> 本站信息由居民自主发布，仅供邻里间参考交流。</li>
        </ul>
      </div>
    </section>
  );
}